(() => {
  // app/scripts/popup-select-store.js
  var popupSelectStore = class extends HTMLElement {
    constructor() {
      super();
      const selectStore2 = document.querySelectorAll(".header-select-store");
      this.locationData = [];
      this.container = this.closest('[data-section-type="popup-select-store-location"]');
      this.weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      window.addEventListener("load", () => {
        this.onLoad();
      });
      document.addEventListener("click", ({ target }) => {
        if (target.closest(".btn-store-favorite")) {
          this.storeSavingCookie(target.closest(".js-store-item"));
          this.displayPopupStore();
          this.buildLocationListLoad();
          document.querySelector("filter-component")?.dispatchEvent(new CustomEvent("change:store"));
        }
        if (target.closest(".btn-store-clear-store")) {
          this.clearFavoriteStore(target.closest(".js-store-item"));
          this.displayPopupStore();
          this.buildLocationListLoad();
          document.querySelector("filter-component")?.dispatchEvent(new CustomEvent("change:store"));
        }
      });
    }
    onLoad() {
      let { container } = this;
      this.mapConfig = JSON.parse(this.container.querySelector("#map-config").innerHTML);
      this.elms = {
        storeListContainer: this.querySelector(".js-store-list"),
        storeItemElements: this.querySelectorAll(".js-store-item"),
        searchForm: this.querySelector(".js-search-form")
      };
      this.markers = this.loadMarkers();
      this.initLocationFilter();
      this.buildLocationListLoad();
      this.displayPopupStore();
      this.backState();
      this.clearInput();
    }
    set open(value) {
      const popup = this.closest("popup-component");
      if (value) {
        this.closeAllCurrentPopups();
        popup.open();
      } else
        popup.close();
    }
    set refresh(sections) {
      const div = document.createElement("div");
      div.innerHTML = sections[this.sectionName];
      this.innerHTML = div.querySelector(this.tagName).innerHTML;
    }
    clearInput() {
      const inputField = this.querySelector(".map-search_zipcode");
      const btnClear = this.querySelector(".btn-clear");
      btnClear.addEventListener("click", () => {
        inputField.value = "";
      });
    }
    closeAllCurrentPopups() {
      document.querySelectorAll("popup-component.active")?.forEach((popup) => {
        popup.close();
      });
    }
    initLocationFilter() {
      let { searchForm } = this.elms;
      searchForm.addEventListener("submit", (e) => {
        e.preventDefault();
        this.markers = this.arrangeAlphabetically(this.markers);
        let { zip, distance, country } = [...new FormData(searchForm).entries()].reduce((accu, value) => {
          accu[value[0]] = value[1];
          return accu;
        }, {});
        if (!zip.trim()) {
          alert(theme.strings.storeLocation.searchMessage);
          return;
        }
        let newZip = zip.toLowerCase().split(" ").join("");
        let matchingMarkerIndex = -1;
        this.markers.forEach((marker, index) => {
          const markerTitle = marker.properties.title.toLowerCase().split(" ").join("");
          const markerPostalCode = marker.properties.postal_code.toLowerCase().split(" ").join("");
          const markerCity = marker.properties.city.toLowerCase().split(" ").join("");
          if (newZip == markerTitle || newZip == markerPostalCode || newZip == markerCity) {
            matchingMarkerIndex = index;
          }
        });
        if (matchingMarkerIndex !== -1) {
          const matchingMarker = this.markers.splice(matchingMarkerIndex, 1)[0];
          this.markers.unshift(matchingMarker);
          this.hasResult = true;
          this.querySelector(".not-found").classList.add("d-none");
          this.querySelector(".store-availability-nearless-result").classList.remove("d-none");
          this.querySelector(".store-availability-nearless-result .js-input-value").innerHTML = `"${zip}"`;
        } else {
          this.querySelector(".store-availability-nearless-result").classList.add("d-none");
          this.querySelector(".not-found .key-search").innerHTML = `"${zip}"`;
          this.querySelector(".not-found").classList.remove("d-none");
          this.hasResult = false;
        }
        this.buildLocationList(zip);
      });
      const zipCode = new URLSearchParams(location.search).get("zip") || null;
      if (document.querySelector(".jsAutoSubmit") || new URLSearchParams(location.search).get("zip")) {
        this.elms.searchForm.querySelector('[name="zip"]').value = zipCode;
        this.elms.searchForm.dispatchEvent(new Event("submit"));
      }
    }
    backState() {
      this.querySelector(".btn-back")?.addEventListener("click", () => {
        this.markers = this.arrangeAlphabetically(this.markers);
        this.buildLocationListLoad();
        const btnClear = this.querySelector(".btn-clear");
        const inputField = this.querySelector(".map-search_zipcode");
        btnClear.classList.remove("active");
        inputField.value = "";
      });
    }
    loadMarkers() {
      this.locationDataOdd = JSON.parse(document.getElementById("store-metaobject").textContent) || [];
      this.locationData = this.locationDataOdd.map((location2) => {
        const container = {};
        container["geometry"] = { "coordinates": [parseFloat(location2.latitude), parseFloat(location2.longitude)] };
        container["properties"] = location2;
        return container;
      });
      this.locationData = this.arrangeAlphabetically(this.locationData);
      return this.locationData;
    }
    arrangeAlphabetically(data) {
      data.sort((a, b) => {
        const titleA = a.properties.title.toUpperCase();
        const titleB = b.properties.title.toUpperCase();
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0;
      });
      return data;
    }
    buildLocationListLoad() {
      this.querySelector(".store-availability-nearless").classList.add("d-none");
      let { storeListContainer } = this.elms;
      let template = storeListContainer.querySelector(".js-template");
      let storeSelectedId;
      let el;
      let temp;
      let tempArr = [];
      storeListContainer.innerHTML = template.outerHTML;
      this.markers.forEach((marker, index) => {
        let { properties, geometry } = marker;
        marker.id = properties["location_id"];
        storeSelectedId = this.getFavoriteStore;
        if (storeSelectedId == marker.id) {
          temp = this.createStore(document.createElement("div"), { ...properties, Quantity: location.quantity }, index);
          tempArr.push(temp);
        } else {
          el = this.createStore(storeListContainer.appendChild(document.createElement("div")), { ...properties, Quantity: location.quantity }, index);
        }
      });
      if (tempArr.length) {
        storeListContainer.insertBefore(temp, storeListContainer.firstElementChild);
      }
    }
    buildLocationList(searchValue) {
      this.querySelector(".js-store-list").classList.remove("d-none");
      let { storeListContainer } = this.elms;
      let template = storeListContainer.querySelector(".js-template");
      let el;
      let jsNumberStore = this.querySelector(".js-number-store");
      let jsInputValue = this.querySelector(".js-input-value");
      storeListContainer.innerHTML = template.outerHTML;
      let number = 0;
      jsInputValue.innerHTML = searchValue;
      this.markers.forEach((marker, index) => {
        let { properties, geometry } = marker;
        marker.id = properties["location_id"];
        number = ++number;
        el = this.createStore(storeListContainer.appendChild(document.createElement("div")), properties, index);
      });
      this.querySelector(".store-availability-nearless").classList.remove("d-none");
      if (this.hasResult) {
        jsNumberStore.innerHTML = number;
      }
    }
    createStore(el, properties, index, markerDistance = null) {
      let { storeListContainer } = this.elms;
      let template = storeListContainer.firstElementChild;
      const address = (!!properties["Full Address"] ? [properties["Full Address"]] : [properties["address"], properties["city"], properties["province"], properties["postal_code"]].filter(Boolean)).join(", ");
      el.innerHTML = template.innerHTML.replaceAll("{{ address }}", address).replaceAll("{{ url }}", properties["store_page"]).replaceAll("{{ name }}", properties["title"]).replaceAll("{{ address1 }}", properties["address"]).replaceAll("{{ state }}", properties["province"]).replaceAll("{{ phone }}", properties["phone"]).replaceAll("{{ phoneCall }}", properties["phone"].replaceAll(/[^0-9]/g, "")).replaceAll("{{ directions }}", properties["directions"]).replaceAll("{{ street }}", properties["street_view"]).replaceAll("{{ hoursWeekday }}", properties["hours_weekday"]).replaceAll("{{ hoursWeekend }}", properties["hours_weekend"]);
      el.setAttribute("data-id", index);
      el.setAttribute("data-location-id", properties["location_id"]);
      el.classList.add("store-item", "js-store-item");
      el.classList.toggle("is-store-favorited", this.getFavoriteStore == +properties["location_id"]);
      return el;
    }
    storeSavingCookie(store) {
      const { localStorage } = theme;
      const locationID = store.getAttribute("data-location-id");
      localStorage("favoriteStore").set(locationID);
      document.querySelectorAll(".store-item.is-store-favorited")?.forEach((i) => {
        i.classList.remove("is-store-favorited");
      });
      document.querySelectorAll(`.store-item[data-location-id="${locationID}"]`).forEach((storeItem) => {
        storeItem.classList.add("is-store-favorited");
      });
    }
    getTimeOpen() {
      const d = /* @__PURE__ */ new Date();
      let day = this.weekday[d.getDay()];
      if (day != "Saturday" || day != "Sunday") {
        day = "Days";
      }
      return day;
    }
    clearFavoriteStore(store) {
      const { localStorage } = theme;
      const locationID = store.getAttribute("data-location-id");
      localStorage("favoriteStore").clear();
      document.querySelectorAll(`.store-item[data-location-id="${locationID}"]`).forEach((storeItem) => {
        storeItem.classList.remove("is-store-favorited");
      });
    }
    displayPopupStore(storeId, markers = this.markers) {
      if (storeId) {
        if (!storeId[0] || storeId[0] == "-1") {
          storeId = [];
        }
      } else {
        storeId = this.getFavoriteStore;
      }
      const selectStore2 = document.querySelectorAll(".header-select-store");
      if (!storeId.length) {
        selectStore2.forEach((item) => {
          if (item.querySelector(".js-selected-store")) {
            item.classList.add("jsPopupSelectStore");
          }
          if (item.querySelector(".js-selected-store")) {
            if (item.classList.contains("jsHidden")) {
              item.style.visibility = "hidden";
            } else {
              item.querySelector(".js-selected-store").innerHTML = "Select my store";
            }
          } else {
            if (item.classList.contains("jsHidden")) {
              item.style.visibility = "hidden";
            }
          }
          if (item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow")) {
            item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow").style.display = "none";
          }
          if (item.querySelector(".dropdown-hover-layer")) {
            item.querySelector(".dropdown-hover-layer").style.display = "none";
          }
          if (item.querySelector("accordion-component")) {
            item.querySelector("accordion-component").style.pointerEvents = "none";
          }
        });
      }
      markers.forEach((marker, index) => {
        let { properties } = marker;
        marker.id = properties["location_id"];
        if (storeId && storeId[0]) {
          if (storeId[0] == properties["location_id"]) {
            selectStore2.forEach((item, index2) => {
              if (item.querySelector(".js-selected-store")) {
                if (item.classList.contains("jsHidden")) {
                  item.style.visibility = "visible";
                }
                item.querySelector(".js-selected-store").innerHTML = `<span>My store</span> <span>${properties["title"]}</span>`;
                item.classList.remove("jsPopupSelectStore");
              } else {
                if (item.classList.contains("jsHidden")) {
                  item.style.visibility = "hidden";
                }
              }
              if (item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow")) {
                item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow").style.display = "block";
              }
              if (item.querySelector(".dropdown-hover-layer")) {
                item.querySelector(".dropdown-hover-layer").style.display = "block";
              }
              if (item.querySelector("accordion-component")) {
                item.querySelector("accordion-component").style.pointerEvents = "initial";
              }
              const address = (!!properties["Full Address"] ? [properties["Full Address"]] : [properties["address"], properties["city"], properties["province"], properties["country"]].filter(Boolean)).join(", ");
              if (item.querySelector(".dropdown-content")) {
                item.querySelector(".dropdown-content .dropdown-content-inner").innerHTML = item.querySelector(".dropdown-content .popup-store-template").innerHTML.replaceAll("{{ url }}", properties["store_page"]).replaceAll("{{ name }}", properties["title"]).replaceAll("{{ address }}", address).replaceAll("{{ directions }}", properties["directions"]).replaceAll("{{ state }}", properties["province"]).replaceAll("{{ phone }}", properties["phone"]).replaceAll("{{ phoneCall }}", properties["phone"].replaceAll(/[^0-9]/g, "")).replaceAll("{{ hoursWeekday }}", properties["hours_weekday"]).replaceAll("{{ hoursWeekend }}", properties["hours_weekend"]);
              }
            });
          }
        }
      });
    }
    // get store collection
    getStore() {
      const storeId = this.getFavoriteStore;
      const markers = this.loadMarkers();
      const foundMarker = markers.find((marker) => {
        let { properties } = marker;
        if (storeId == properties["location_id"]) {
          return true;
        }
        return false;
      });
      if (foundMarker) {
        return {
          storeID: `${storeId}`,
          storeName: `${foundMarker.properties.title}`
        };
      }
      return null;
    }
    get getFavoriteStore() {
      const { localStorage } = theme;
      const value = localStorage("favoriteStore")?.get();
      return value;
    }
  };
  customElements.define("popup-select-store", popupSelectStore);
  var selectStore = document.querySelectorAll(".header-select-store");
  selectStore.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (!item.classList.contains("jsPopupSelectStore")) {
        item.querySelector(".dropdown-hover-layer")?.classList.toggle("active");
        setTimeout(() => {
          item.querySelector(".dropdown-hover-layer")?.classList.remove("active");
        }, 3e3);
      }
      if (e.target.closest(".btn-close")) {
        item.querySelector(".dropdown-hover-layer").classList.remove("active");
      }
    });
  });
  var pageName = window.location.pathname.split("pages/")[1];
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".jsPopupSelectStore"))
      return;
    e.preventDefault();
    if (pageName != "store-locator") {
      document.querySelector("popup-select-store").open = true;
    }
  });
})();
